import { render, staticRenderFns } from "./SplitView.vue?vue&type=template&id=719f0043&"
import script from "./SplitView.vue?vue&type=script&lang=js&"
export * from "./SplitView.vue?vue&type=script&lang=js&"
import style0 from "./SplitView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports